<template>
    <div>
        <strong class="headline">Besøgstid på hjemmeside</strong>

        <p class="text-muted">
            I gennemsnit er besøgende på din hjemmeside i {{value}} sekunder. Besøgende opholder sig længere tid på din hjemmeside end konkurrenterne i din branche, som i gennemsnit har deres besøgende {{benchmark}} sekunder på deres hjemmeside.
        </p>

        <div class="well" v-if="!value || !benchmark">
            Kan ikke hente data
        </div>

        <benchmark-chart :value="value" :benchmark="benchmark" :unit="'sekunder'" v-else></benchmark-chart>
    </div>
</template>

<style lang="scss" scoped>
        .headline {
            font-size: 18px;
            margin-top: 30px;
            display: block;
        }
</style>

<script>
    import BenchmarkChart from '@/app/news-feed/components/feed/content/sub-content/BenchmarkChart'

    export default {
        props: {
            activity: Object,
            isSubActivity: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            value() {
                const details = this.activity.details

                if (!details.benchmark) {
                    return null
                }

                return Math.round(details.benchmark.value)
            },

            benchmark() {
                const details = this.activity.details

                if (!details.benchmark) {
                    return null
                }

                return Math.round(details.benchmark.benchmark)
            }
        },

        components: {
            BenchmarkChart,
        },
    }
</script>
